import { ICollection, IGif } from "services/types";

export interface ICollectionState {
  collections: ICollection[];
  currentCollection: ICollection | null;
  collectionsOwnerName: string;
  gifs: IGif[];
  total: number;
  totalGifs: number;
  loading: boolean;
  error: Error | null;
  newCollectionId: string | null;
}

const defaultState = {
  collections: [],
  currentCollection: null,
  collectionsOwnerName: "",
  total: 0,

  gifs: [],
  totalGifs: 0,
  newCollectionId: null,

  loading: false,
  error: null
};

export const getDefaultCollectionsState = () => defaultState;
